import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { LogIn } from "lucide-react";

export const AdminLogin = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back, admin.");
      nav("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-grid px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md card-soft">
        <Link to="/" className="flex items-center gap-2 font-heading text-2xl font-bold text-[#0A3B32]">
          <span className="inline-flex w-9 h-9 rounded-lg bg-[#0A3B32] text-white items-center justify-center font-heading text-lg font-bold">
            B
          </span>
          BIOMAC
        </Link>
        <h1 className="mt-6 font-heading text-3xl font-semibold text-[#0A3B32]">Admin Login</h1>
        <p className="mt-2 text-sm text-slate-500">Sign in to manage courses & enquiries.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">Email</label>
            <input
              data-testid="admin-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-slate-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0A3B32]/30"
              placeholder="admin@biomac.in"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">Password</label>
            <input
              data-testid="admin-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-slate-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0A3B32]/30"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="btn-primary w-full disabled:opacity-60"
          >
            <LogIn size={18} />
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <Link to="/" className="mt-4 inline-block text-xs text-slate-500 hover:text-slate-800">
          ← Back to site
        </Link>
      </div>
    </div>
  );
};
